export const welcomeChat = [
  {
    p1: "Hi! My name is Marge!",
    p2: "If you know what you are looking for, feel free to click Skip.",
    p3: "If you want to find out what the shucks is going on here, click Continue.",
  },
  {
    p1: "Let me explain a little bit then!",
    p2: "My name is Marge. I'm a Machine Learning Algorythm inside a Chat Bot.",
    p3: "That means that I try to understand what you ask thanks to a lot of math and provided examples."
  },
  {
    p1: "I was created to provide answers to questions of the sexual realm.",
    p2: "There are things that you may want to know, but you're not sure where to find the answers.",
    p3: "For example: 'What's a schlong?' or 'How long should sex last?'",
  },
  {
    p1: "I do not know who you are or where you are from. This website DOES NOT save cookies, caches, or any other data related to you.",
    p2: "Or any data at all, really.",
    p3: "You can check that by refreshing this page: I will have no idea if you've been here before.",
  },
  {
    p1: "The best way to talk with me is by using simple phrases. I learn every day, but it's a slow process.",
    p2: "If I don't know the answer to your question, please try and ask it again in a few days.",
    p3: "All questions are passed through the algorythm and can be read by humans, who teach me how to answer.",
  },
  {
    p1: "So there's a chance that I will know something more when you come back.",
    p2: "And again: no one will know who asked any particular question.",
    p3: "Your question is the only piece of data passed through the algorythm and to the human programmers.",
  },
  {
    p1: "My answers are built mostly on the base of Wikipedia articles.",
    p2: "A few times the Urban Dictionary turned out to be useful.",
    p3: "😉",
  },
  {
    p1: "To sum up:",
    p2: "1. I don't know who you are.",
    p3: "2. Please try to ask simple questions."
  },
  {
    p1: "Are you ready to give this algorythm a whirl?",
    p2: "All you have to do is click Continue.",
    p3: "Have fun!"
  }
];
